import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import SharePage from "./Share";
import NotFoundPage from "./404";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={"*"} element={<NotFoundPage/>}/>
        {/* //http://localhost:3000/shared/game/123?code=dddd */}
        <Route path={"/game/:game"} element={<SharePage/>}/>
      </Routes>
    </BrowserRouter>
  );
}
